import request from "../request";
import { REACT_BASE_URL_GAMA_USERS } from "../url";

export const sendZohoPayload = async (data) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/contact/zoho`,
    method: "POST",
    data,
  });
};

export const sendUsedPayload = async (data) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/contact/used`,
    method: "POST",
    data,
  });
};

export const sendReportChannelPayload = async (data) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/contact/report`,
    method: "POST",
    data,
  });
};

export const sendReportChannelPayloadWithFile = async (data, files) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/contact/report/files`,
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: {
      ...data,
      files,
    },
  });
};

export const uploadFilesOnReportChannelBucket = async (file) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/upload/dev-gama-denuncias/${file?.name}`,
    method: "PUT",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: file,
  });
};
